module.exports = __webpack_public_path__ + "static/media/cq_modifica_documento b.972ebc96.svg";